import React, { useEffect, useState } from "react";
import { Box } from "theme-ui";
import { pdf } from "@react-pdf/renderer";

import { createImages } from "api";
import { Button, PDFContent } from "components";
import { loadingIndicatorGif } from "./loadingIndicatorGif";

export default function DownloadSpecsButton({
  userChoicesForUiV2,
  userChoiceValues,
  headerBackgroundColour,
  appHeaderLogo,
  productLogo,
  recipeID,
  iconBefore,
  reviewProduct,
  productName,
  images,
  children,
  publicDirectoryUrl,
  sx: sxProps,
}) {
  const [isLoadingPDF, setIsLoadingPDF] = useState(false);
  const [finalImagesArray, setFinalImagesArray] = useState(null);
  const [abortFn, setAbortFn] = useState(null);

  function getOrCreateImage({ controller }) {
    if (finalImagesArray) {
      return Promise.resolve(finalImagesArray);
    }
    return createImages({ signal: controller.signal, images });
  }

  function loadPDFData() {
    const controller = new AbortController();
    setAbortFn(() => () => controller.abort());
    setIsLoadingPDF(true);
    getOrCreateImage({ controller }).then((imagesResponse) => {
      return pdf(
        PDFContent({
          userChoicesForUiV2: userChoicesForUiV2,
          userChoiceValues: userChoiceValues,
          appHeaderLogo: appHeaderLogo,
          headerBackgroundColour: headerBackgroundColour,
          productLogo: productLogo,
          recipeID: recipeID,
          images: imagesResponse,
          publicDirectoryUrl,
        })
      )
        .toBlob()
        .then((blob) => {
          const a = document.createElement("A");
          a.href = URL.createObjectURL(blob);
          a.download = `${productName} ${reviewProduct} ${recipeID.toUpperCase()}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);

          setFinalImagesArray(imagesResponse);
          setIsLoadingPDF(false);
          setAbortFn(null);
        });
    });
  }

  useEffect(() => {
    return () => {
      if (abortFn) {
        abortFn.call(null);
      }
    };
  }, [abortFn]);

  return (
    <Button
      iconBefore={
        isLoadingPDF ? (
          <Box
            as="img"
            src={loadingIndicatorGif}
            alt="Loading..."
            sx={{ height: "26px", display: "block" }}
          />
        ) : (
          iconBefore
        )
      }
      variant="unstyled"
      disabled={isLoadingPDF || !recipeID}
      sx={sxProps}
      onClick={loadPDFData}
    >
      {children}
    </Button>
  );
}
